// @flow
import { combineReducers } from 'redux';

import type { ERROR_TYPE } from '../types/common';
import * as types from '../types/phoneCodeRequest';
import * as common from './common';

export type PhonecoderequestState = {
  isLoading: boolean,
  error: ERROR_TYPE
};

const isLoading = common.isFetching({
  started: [types.PHONE_CODE_REQUEST_STARTED],
  succeed: [types.PHONE_CODE_REQUEST_SUCCEED],
  failed: [types.PHONE_CODE_REQUEST_FAILED],
});

const error = common.error({
  clear: [
    types.PHONE_CODE_REQUEST_STARTED,
    types.PHONE_CODE_REQUEST_SUCCEED,
    '@@redux-form/CHANGE', // TODO: import from redux form
  ],
  populate: [types.PHONE_CODE_REQUEST_FAILED],
});

const phoneCodeRequest = combineReducers({
  isLoading,
  error,
});

export default phoneCodeRequest;

export const isPhoneCodeRequestLoading = (state: PhonecoderequestState): boolean => state.isLoading;
export const phoneCodeRequestError = (state: PhonecoderequestState): ERROR_TYPE => state.error;



// WEBPACK FOOTER //
// ./src/scripts/reducers/phoneCodeRequest.js